import { useState, useContext, useEffect } from "react";
import { DispatchContext } from "App";
import { useQuery } from "@apollo/client";

export * from "./useRole";
export * from "./useTokenExpiration";

export const useDispatch = (): any => {
  const { dispatch } = useContext(DispatchContext);
  return dispatch;
};

export const useQueryCustom = (query: any, options?: any): any => {
  const dispatch = useDispatch();
  const [completed, setCompleted] = useState(false);

  const response = useQuery(query, {
    fetchPolicy: "no-cache",
    onError: () => {
      dispatch({ type: "loading", value: false });
      dispatch({ type: "server_error", value: true });
    },
    ...options
  });

  useEffect(() => {
    setCompleted(false);
  }, []); // eslint-disable-line

  useEffect(() => {
    dispatch({ type: "loading", value: true });
  }, []); // eslint-disable-line

  const data = response.data ?? response.previousData ?? undefined;

  if (data && !response.loading && !completed) {
    setCompleted(true);
    dispatch({ type: "loading", value: false });
  }

  return { ...response, data };
};
